/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sync_Rounds_RequiredInputs */



/**
* | output |
* | --- |
* | "Configure the number of rounds before publishing to VEKN." |
*
* @param {Vekn_Sync_Rounds_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sync_rounds_required = /** @type {((inputs?: Vekn_Sync_Rounds_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sync_Rounds_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurez le nombre de rondes avant de publier auprès de la VEKN.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configure el número de rondas antes de publicar en la VEKN.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Configure o número de rodadas antes de publicar na VEKN.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configuri il numero di round prima di pubblicare sulla VEKN.")
	return /** @type {LocalizedString} */ ("Configure the number of rounds before publishing to VEKN.")
});